module.exports = __webpack_public_path__ + "static/media/icon_language_black.30b3c3a5.svg";